module.exports = __webpack_public_path__ + "img/digital35.c9ad1bc9.png";